import axios from 'axios'
import { MessageBox, Message, Loading } from "element-ui";
let loading = null
const showloading = ()=>{
  loading = Loading.service({
        lock: true,
        text: '加载中...',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.1)'
    });
}

const hideloading=()=>{
    if (loading) {
        loading.close();
    }

}
const service = axios.create({
    baseURL: "",
    timeout: 5000,
  });
  // request interceptor
  service.interceptors.request.use(
    // config：配置对象
   (config) => {
        showloading()
        config.headers["Authorization"] = localStorage.getItem('token');
        return config;
    },
    (error) => {
      console.log(error);
      hideloading()
      return Promise.reject(error);
    }
  );
  
  // response interceptor
  service.interceptors.response.use(
    (response) => {
      hideloading()
      const res = response.data;
      if(res.code ===undefined){
        return res
      }
      else{
        if (res.code !== 200) {
          Message({
            message: res.msg || "Error",
            type: "error",
            duration: 2 * 1000,
          });
          return Promise.reject(new Error(res.msg || "Error"));
        } else {
          return res;
        }
      }
      
    },
    (error) => {
      console.log("err" + error); // for debug
      Message({
        message: error.message,
        type: "error",
        duration: 2 * 1000,
      });
    hideloading()

      return Promise.reject(error);
    }
  );
  
  export default service;
